import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const createRole = (data) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.ADMIN.ROLES_AND_PERMISSION.CREATE_ROLE,
    data
  );
};

export default createRole;
